import gql from 'graphql-tag';

import type {
  SendVerificationEmailRequest,
  SendVerificationEmailResponse,
} from '@coursera/grpc-types-useremails/coursera/proto/useremails/v1beta1/user_emails_api';

export type SendVerificationEmailVariables = { input: SendVerificationEmailRequest };
export type SendVerificationEmailResult = { sendVerificationEmail: SendVerificationEmailResponse };

export const SendVerificationEmailMutation = gql`
  mutation sendVerificationEmailMutation($input: DataMap!) {
    sendVerificationEmail(input: $input)
      @rest(
        type: "SendVerificationEmailResponse"
        path: "grpc/useremails/v1beta1/UserEmailsAPI/SendVerificationEmail"
        method: "POST"
      ) {
      __typename
    }
  }
`;
